export default class BaseRPCHandler {
    constructor(method) {
        this.method = method;
    }

    async handle(provider, request) {

    }
}